"use client"

import { Grip } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GripIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GripIcon = component(Icon)({ as: Grip })
